/**
 * UserCircle — универсальный кружок сотрудника.
 * Показывает фото (avatar_thumb_url) если есть, иначе инициалы.
 *
 * Props:
 *   name        {string}  — имя пользователя (для инициалов)
 *   avatarUrl   {string}  — presigned URL thumb-фото (опционально)
 *   size        {number}  — диаметр в px (default: 32)
 *   fontSize    {number}  — размер шрифта инициалов (default: авто)
 *   style       {object}  — дополнительные стили на корневой div
 */
export default function UserCircle({ name = '', avatarUrl, size = 32, fontSize, style = {} }) {
  const initials = name.split(' ').map(w => w[0]).filter(Boolean).slice(0, 2).join('').toUpperCase() || '?';
  const fs = fontSize ?? Math.round(size * 0.38);

  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', flexShrink: 0,
      background: avatarUrl ? 'transparent' : 'var(--bg3)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: fs, fontWeight: 600, color: 'var(--text2)',
      overflow: 'hidden',
      ...style,
    }}>
      {avatarUrl
        ? <img src={avatarUrl} alt={initials} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        : initials
      }
    </div>
  );
}
